import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en/translation.json';
import arTranslations from './locales/ar/translation.json';

import mobileEn from './locales/mobile/en.json';
import mobileAr from './locales/mobile/ar.json';
import mobileFr from './locales/mobile/fr.json';

i18n
  .use(LanguageDetector) // Detects user language from browser
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
        mobile: mobileEn,
      },
      ar: {
        translation: arTranslations,
        mobile: mobileAr,
      },
      fr: {
        translation: {},
        mobile: mobileFr,
      },
    },
    ns: ['translation', 'mobile'],
    defaultNS: 'translation',
    fallbackLng: 'en', // Default language
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

const getBaseLanguage = (language) => String(language || "en").split("-")[0].toLowerCase();

const applyDocumentLanguageDirection = (language) => {
  if (typeof document === "undefined") return;

  const baseLanguage = getBaseLanguage(language);
  const isArabic = baseLanguage === "ar";
  const direction = isArabic ? "rtl" : "ltr";

  document.documentElement.dir = direction;
  document.documentElement.lang = baseLanguage;
  document.body?.setAttribute("dir", direction);
};

applyDocumentLanguageDirection(i18n.language);
i18n.on("languageChanged", applyDocumentLanguageDirection);

/**
 * Change locale then fully reload the page so the UI and any language-dependent
 * fetches re-run with the new language (avoids slow or stale translations).
 * @param {string} lng
 * @param {string} [redirectPath] - If set, load this path (full page); otherwise reload the current URL.
 */
export const changeLanguageWithReload = (lng, redirectPath) => {
  if (!lng) return;
  if (getBaseLanguage(i18n.language) === getBaseLanguage(lng)) {
    if (typeof window !== "undefined" && redirectPath) {
      window.location.assign(redirectPath);
    }
    return;
  }
  i18n.changeLanguage(lng).then(() => {
    if (typeof window === "undefined") return;
    if (redirectPath) {
      window.location.assign(redirectPath);
    } else {
      window.location.reload();
    }
  });
};

export default i18n;

